<template>
  <div class="outer">
    <!-- Dialog -->
    <v-dialog
      v-model="dialog"
      fullscreen
      hkeye-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grkey-list-md>
            <v-layout wrap>
              <v-flex xs6>
                <v-switch
                  :label="`Location Covered by Guardians?: ${editedItem.covered ? 'Yes' : 'No'}`"
                  v-model="editedItem.covered"
                ></v-switch>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.title"
                  label="Title"
                  :rules="[rules.required]"
                  counter="100"
                  max="100"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.area"
                  label="Area"
                  :rules="[rules.required]"
                  hint="Possible values: banglore/chennai/cochin"
                  persistent-hint
                ></v-text-field>
              </v-flex>

              <v-flex xs6>
                <v-text-field
                  v-model="editedItem.lat"
                  label="Lattitude"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="editedItem.lng"
                  label="Longitude"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.order"
                  label="Order"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-spacer></v-spacer>
                <v-btn
                  color="accent"
                  @click.native="save"
                >Save</v-btn>
                <v-btn
                  color
                  @click.native="close "
                >Cancel</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card height="100%">
      <v-card-title class="title">Locations
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="locationList"
        :search="search"
        :rows-per-page-items="[25, 50, 100, 250]"
      >
        <template
          slot="items"
          slot-scope="props "
        >
          <td class="text-xs-left">{{ props.item.title }}</td>
          <td class="text-xs-left">{{ props.item.area }}</td>
          <td class="text-xs-left">{{ props.item.lat }}</td>
          <td class="text-xs-left">{{ props.item.lng }}</td>
          <td class="text-xs-center">{{ props.item.covered? 'Yes' : 'No'}}</td>
          <td class="text-xs-left">{{ props.item.order }}</td>
          <td class="justify-center layout px-0">
            <v-btn
              icon
              class="mx-0"
              @click="editItem(props.item) "
            >
              <v-icon color="info ">edit</v-icon>
            </v-btn>
            <v-btn
              icon
              class="mx-0"
              @click="deleteItem(props.item) "
            >
              <v-icon color="error ">delete</v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="no-data ">Loading Data...</template>
      </v-data-table>

      <v-btn
        fab
        bottom
        left
        fixed
        color="accent "
        @click.stop="dialog=! dialog "
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-card>
  </div>
</template>


<script>
import marked from "marked";
export default {
  data: () => ({
    dialog: false,
    search: "",
    headers: [
      {
        text: "Title",
        value: "title",
        align: "left"
      },
      {
        text: "Area",
        value: "area",
        align: "left"
      },
      {
        text: "Lat",
        value: "lat"
      },
      {
        text: "Lng",
        value: "lng"
      },
      {
        text: "Covered?",
        value: "covered"
      },
      {
        text: "Order",
        value: "order",
        align: "right"
      },
      { text: "Actions", value: "name", sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
      key: "unique-location-key",
      title: "Sample title",
      area: "",
      lat: "",
      lng: "",
      covered: false
    },
    defaultItem: {
      key: "unique-location-key",
      title: "Sample title",
      area: "",
      lat: "",
      lng: "",
      covered: false
    },

    rules: {
      required: value => !!value || "Required."
    }
  }),

  computed: {
    locationList() {
      return this.$store.getters.locationList;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add a new Location" : "Edit a Location";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  mounted() {
    this.editedItem = Object.assign({}, this.defaultItem);
    this.editedIndex = -1;
  },

  methods: {
    editItem(item) {
      this.editedIndex = this.locationList.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      confirm("Are you sure you want to delete this item?") &&
        this.$store.dispatch("deleteLocation", item);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        this.$store.dispatch("saveLocation", this.editedItem);
      } else {
        this.$store.dispatch("addLocation", this.editedItem);
      }

      this.close();
    }
  }
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/pages/LocationsPage.vue